import HttpService from '../../../core/rest/http.service';
export async function loadServices(categoryId, showSiteUrl, servicesGroupId, structureGroupId, vocabularyGroupId) {
    let parameters = {};
    parameters = {
        kategorieId: categoryId,
        showSiteUrl,
        sluzbyGroupId: servicesGroupId || undefined,
        structureGroupId: structureGroupId || undefined,
        vocabularyGroupId: vocabularyGroupId || undefined,
    };
    Object.entries(parameters).forEach(([key, value]) => {
        if (value === undefined)
            delete parameters[key];
    });
    const endpoint = "/search/sluzby";
    return HttpService.get(endpoint, parameters);
}
